import { AppointmentBookStatus } from '@/models/appointment.ts';
import { z } from 'zod';

import { CollectionStatus, CollectionType } from '@/utils/constants.js';

const preBookedAppointmentSchema = z.object({
    id: z.string().min(1),
    status: z.enum(AppointmentBookStatus),
    collection_id: z.string().optional(),
    chain_configuration_id: z.string().optional(),
    collection_data: z
        .object({
            position: z.number().int().positive(), // 1-based
            total_appointments: z.number().int().positive(),
            chain_name: z.object({ en: z.string(), de: z.string() }).optional(),
        })
        .optional(),
    professional: z.object({ id: z.string(), key: z.string(), type_key: z.string() }),
    name: z.string(),
    start: z.string(),
    end: z.string(),
    duration: z.object({ value: z.number(), units: z.string() }),
    data: z.object({
        services: z.array(
            z.object({ id: z.string().optional(), key: z.string(), name: z.string(), is_mapped: z.boolean() })
        ),
    }),
});

const collectionSchema = z.object({
    id: z.string().min(1),
    type: z.enum(CollectionType),
    booking_status: z.enum(CollectionStatus),
});

export const bookCollectionResponseSchema = z.object({
    collection: collectionSchema,
    pre_booked_appointments: z.array(preBookedAppointmentSchema),
});

export type PreBookedAppointment = z.infer<typeof preBookedAppointmentSchema>;
export type BookCollectionResponse = z.infer<typeof bookCollectionResponseSchema>;
